<template>
  <TopBarIndex />
  <div class="wrapper-page">
    <div class="container ">

      <div class="alert alert-warning mb-5 d-none d-sm-block" role="alert" style="margin-top: -120px;">
        <h4 class="alert-heading">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> 重要公告
        </h4>
<!--        <div class="marquee overflow-hidden">-->
<!--          <span class="mr-3">[重要公告 111] 系統預定於5/15 11:00-14:00 停機執行資科局網域連線安全檢測及設定，含路燈管理、換裝、績效系統請勿於此時段內操作，檢測完成後另行通知。</span>-->
<!--          <span class="mr-3">[重要公告 222] 系統預定於5/15 11:00-14:00 停機執行資科局網域連線安全檢測及設定，含路燈管理、換裝、績效系統請勿於此時段內操作，檢測完成後另行通知。</span>-->

<!--          <span class="mr-3">[2] 系統預定於5/15</span>-->
<!--        </div>-->
        <div class="marquee overflow-hidden">
          <template v-for="(item, key) in marguees" :key="key">
            <span class="mr-3">[系統公告] {{ item.content }}</span>
          </template>
        </div>
      </div>

      <div>
        
      </div>
      <div class="row d-sm-flex justify-content-center d-none ">
        <div class="col-6 col-sm-4 col-md-4 col-lg-3">
          <a href="./dashboard" class="card card-body card-btn" v-if="get_system_permission(1) != 0">
            <img src="/assets/images/svg/menu_dashboard.svg" alt="">
            <h4 class="mt-4 mb-0">Dashboard</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_dashboard.svg" alt="">
            <h4 class="mt-4 mb-0">Dashboard</h4>
          </a>
        </div>

        <div class="col-6 col-sm-4 col-md-4 col-lg-3">
          <a href="./change/map" class="card card-body card-btn" v-if="get_system_permission(3) != 0">
            <img src="/assets/images/svg/menu_change.svg" alt="">
            <h4 class="mt-4 mb-0">換裝管理</h4>
          </a>
          <a href="./change/map" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_change.svg" alt="">
            <h4 class="mt-4 mb-0">換裝管理</h4>
          </a>
        </div>

        <div class="col-6 col-sm-4 col-md-4 col-lg-3">
          <a href="./property/map" class="card card-body card-btn" v-if="get_system_permission(1) != 0">
            <img src="/assets/images/svg/menu_property.svg" alt="">
            <h4 class="mt-4 mb-0">資產管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_property.svg" alt="">
            <h4 class="mt-4 mb-0">資產管理</h4>
          </a>
        </div>
       
      </div>

      <div class="row pt-4 d-sm-flex justify-content-center d-none ">
        
        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./streetlight/map" class="card card-body card-btn" v-if="get_system_permission(1) != 0">
            <img src="/assets/images/svg/menu_lamp.svg" alt="">
            <h4 class="mt-4 mb-0">智能路燈</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_lamp.svg" alt="">
            <h4 class="mt-4 mb-0">智能路燈</h4>
          </a>
        </div>

        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./repair/map" class="card card-body card-btn" v-if="get_system_permission(2) != 0">
            <img src="/assets/images/svg/menu_repair.svg" alt="">
            <h4 class="mt-4 mb-0">報修管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_repair.svg" alt="">
            <h4 class="mt-4 mb-0">報修管理</h4>
          </a>
        </div>


        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./performance" class="card card-body card-btn" v-if="get_system_permission(4) != 0">
            <img src="/assets/images/svg/menu_performance.svg" alt="">
            <h4 class="mt-4 mb-0">績效管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_performance.svg" alt="">
            <h4 class="mt-4 mb-0">績效管理</h4>
          </a>
        </div>

        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./system" class="card card-body card-btn" v-if="get_system_permission(0) != 0">
            <img src="/assets/images/svg/menu_system.svg" alt="">
            <h4 class="mt-4 mb-0">系統管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_system.svg" alt="">
            <h4 class="mt-4 mb-0">系統管理</h4>
          </a>
        </div>
      </div>

      <div class="d-block d-sm-none m-t-40">
        <div class="row d-flex justify-content-start">
        <div class="col-6 col-sm-4 col-md-4 col-lg-3">
          <a href="./dashboard" class="card card-body card-btn" v-if="get_system_permission(1) != 0">
            <img src="/assets/images/svg/menu_dashboard.svg" alt="">
            <h4 class="mt-4 mb-0">Dashboard</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_dashboard.svg" alt="">
            <h4 class="mt-4 mb-0">Dashboard</h4>
          </a>
        </div>

        <div class="col-6 col-sm-4 col-md-4 col-lg-3">
          <a href="./change/map" class="card card-body card-btn" v-if="get_system_permission(3) != 0">
            <img src="/assets/images/svg/menu_change.svg" alt="">
            <h4 class="mt-4 mb-0">換裝管理</h4>
          </a>
          <a href="./change/map" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_change.svg" alt="">
            <h4 class="mt-4 mb-0">換裝管理</h4>
          </a>
        </div>

        <div class="col-6 col-sm-4 col-md-4 col-lg-3">
          <a href="./property/map" class="card card-body card-btn" v-if="get_system_permission(1) != 0">
            <img src="/assets/images/svg/menu_property.svg" alt="">
            <h4 class="mt-4 mb-0">資產管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_property.svg" alt="">
            <h4 class="mt-4 mb-0">資產管理</h4>
          </a>
        </div>
       
        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./streetlight/map" class="card card-body card-btn" v-if="get_system_permission(1) != 0">
            <img src="/assets/images/svg/menu_lamp.svg" alt="">
            <h4 class="mt-4 mb-0">智能路燈</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_lamp.svg" alt="">
            <h4 class="mt-4 mb-0">智能路燈</h4>
          </a>
        </div>

        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./repair/map" class="card card-body card-btn" v-if="get_system_permission(2) != 0">
            <img src="/assets/images/svg/menu_repair.svg" alt="">
            <h4 class="mt-4 mb-0">報修管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_repair.svg" alt="">
            <h4 class="mt-4 mb-0">報修管理</h4>
          </a>
        </div>


        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./performance" class="card card-body card-btn" v-if="get_system_permission(4) != 0">
            <img src="/assets/images/svg/menu_performance.svg" alt="">
            <h4 class="mt-4 mb-0">績效管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_performance.svg" alt="">
            <h4 class="mt-4 mb-0">績效管理</h4>
          </a>
        </div>

        <div class="col-6 col-sm-3 col-md-3 col-lg-3">
          <a href="./system" class="card card-body card-btn" v-if="get_system_permission(0) != 0">
            <img src="/assets/images/svg/menu_system.svg" alt="">
            <h4 class="mt-4 mb-0">系統管理</h4>
          </a>
          <a href="javascript:void(0);" class="card card-body card-btn disabled" disabled v-else>
            <img src="/assets/images/svg/menu_system.svg" alt="">
            <h4 class="mt-4 mb-0">系統管理</h4>
          </a>
        </div>
      </div>


      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { api } from "../../../apis/main.js"
import TopBarIndex from "../../../components/TopBarIndex.vue"
//get_system_permission id參考
import { sub_system_index } from '../../system/config.js'
let $ = window.$;
export default {
  name: 'EntryView',
  props: {
  },
  components: {
    TopBarIndex,
  },
  data() {
    return {
      // systems: sub_system_index,
      page_permission: undefined,
      system_permission: undefined,
      jwt: undefined,
      marguees: [],
    }
  },
  mounted() {
    this.page_permission = localStorage.getItem('page_permission');
    this.system_permission = localStorage.getItem('system_permission');
    this.jwt = localStorage.getItem('jwt');

    if (!this.system_permission || !this.page_permission || !this.jwt) {
      window.location.href = '/login';
    } else {
      let params = 'token=' + this.jwt;
      api.post("check_token", params).then(res => {
        if (res.data.code != 1000) {
          window.location.href = '/login';
        }
      }).catch(error => {
        window.location.href = '/login';
      });
    }
    this.indexMarquees()
  },
  methods: {
    get_system_permission(id) {
      if (this.system_permission) {
        return this.system_permission.charAt(id);
      }
      return 0
    },
    async indexMarquees() {
      await api.post('sm3_1_4?is_index=true').then(res => {
        this.marguees = res.data.data
      }).catch(() => {

      })
      await this.marquees_start()
    },
    marquees_start(){
      $('.marquee').marquee({
        //duration in milliseconds of the marquee
        duration: 20000,
        //gap in pixels between the tickers
        // gap: 50,
        //time in milliseconds before the marquee will start animating
        delayBeforeStart: 0,
        //'left' or 'right'
        direction: 'left',
        //true or false - should the marquee be duplicated to show an effect of continues flow
        duplicated: false
      });
    }
  }
}
</script>

<style scoped>

</style>
